import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1.75 3h20.5s1 0 1 1v16s0 1-1 1H1.75s-1 0-1-1V4s0-1 1-1M12 6.75v6"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.25 16.5a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0"
    }, null, -1)
  ]));
}
const interfaceAlertErrorExclamationBlockSquare = { render };
export {
  interfaceAlertErrorExclamationBlockSquare as default,
  render
};
//# sourceMappingURL=interface-alert-error-exclamation-block-square.svg.js.map
